module.exports = __webpack_public_path__ + "media/en_au_s2_Fiona.fb153c9d.oga";